import { useTournamentRegistrationsContext } from "../contexts/TournamentRegistrations";

import { alertActions } from "../../../../../features/alert/alertSlice";
import { useAppDispatch } from "../../../../../hooks/reduxHooks";
import { updateOrder } from "../../../../../lib/api";
import { IOrder } from "../../../../../types/api";

const useOrderStatusHandler = () => {
    const { setOrders, setFetchStatus } = useTournamentRegistrationsContext();
    const dispatch = useAppDispatch();

    const handleStatusChange = async (
        orderId: IOrder["id"],
        status: IOrder["status"],
    ) => {
        setFetchStatus("pending");
        await updateOrder(orderId, status as IOrder["status"])
            .then(response => {
                setOrders(prev =>
                    prev.map(o =>
                        o.id === orderId
                            ? {
                                  ...o,
                                  status: status,
                                  completionDate: new Date().toString(),
                              }
                            : o,
                    ),
                );
                dispatch(
                    alertActions.success({
                        title: `Order updatd successfully`,
                        dismissible: true,
                    }),
                );
            })
            .catch(e => {
                dispatch(
                    alertActions.error({
                        title: `The server encountered a problem updating the order.`,
                        text: "If the problem continues, please reach out to an admin.",
                        dismissible: true,
                    }),
                );
            })
            .finally(() => {
                setFetchStatus("success");
            });
    };

    return { handleStatusChange };
};

export default useOrderStatusHandler;
